define('views/modules/member/member/member-lists-controller',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // collections
    'collections/member/profiles',
    'collections/member/supervisors',
    // services
    'services/user',
    'services/events/calendar-events',
    'services/events/user-events',
    // views
    'views/modules/member/member/lists/member-list',
    'views/parts/alert/alert-no-data',
    // templates
    'text!templates/modules/member/member/member-lists-controller.html',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // collections
    CProfiles,
    Supervisors,
    // services
    User,
    CalendarEvents,
    UserEvents,
    // views
    VMemberList,
    VAlertNoData,
    // templates
    TMemberListsController

) {

    /**
     * Controls the 3 lists of member
     */
    var VMemberListsController = Backbone.View.extend({
        template: TMemberListsController,
        regions: {
            active: "#member-list-active",
            pending: "#member-list-pending",
            inactive: "#member-list-inactive",
            alert: ".empty-list-alert"
        },

        initialize: function(opt) {
            opt = opt || {};
            this.url = opt.url;

            var model = this.model,
                groups = this.groups = opt.groups,
                allStatusCombinedMembers = this.allStatusCombinedMembers = new CProfiles(),
                commonListOptions = {
                    model: model,
                    groups: groups,
                    supervisors: Supervisors,
                    allStatusCombinedMembers: allStatusCombinedMembers
                },
                view = this.view = {
                    active: new VMemberList(_.extend({
                        title: "Active clients",
                        status: "active",
                        icon: "sl-icon-user-following",
                    }, commonListOptions)),
                    pending: new VMemberList(_.extend({
                        title: "Pending clients",
                        status: "pending",
                        icon: "sl-icon-clock",
                    }, commonListOptions)),
                    inactive: new VMemberList(_.extend({
                        title: "Inactive clients",
                        status: "expired",
                        icon: "sl-icon-user-unfollow",
                    }, commonListOptions)),
                    alert: new VAlertNoData({
                        title: 'No members yet',
                        subtitle: 'Click on + to add new members to the group',
                        collection: allStatusCombinedMembers,
                        caret: false
                    })
                };

            var listListeners = {
                'click': this.onMemberClick,
                'edit': this.onMemberEdit,
                'active': this.onMemberActive,
                'remove': this.onMemberRemove,
            };

            // listeners
            this.listenTo(view.active.getCollection(), listListeners)
                .listenTo(view.pending.getCollection(), listListeners)
                .listenTo(view.inactive.getCollection(), listListeners);

            this.listenTo(UserEvents, 'testUserAdded', this.onTestUserAdded);
            this.listenTo(UserEvents, 'member:added', this.onMemberAdded);
        },

        render: function() {
            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext()));

            this.generateZones();
            var view = this.view,
                zone = this.zone;

            this.assign(view.active, zone.$active)
                .assign(view.pending, zone.$pending)
                .assign(view.inactive, zone.$inactive)
                .assign(view.alert, zone.$alert);

            return this;
        },

        unselect: function() {
            this.$('.item-section.active').removeClass('active');
        },

        addMember: function(model) {
            model = model.clone();
            var list = model.get('_isExpired') ? 'inactive' :
                model.get('_isPending') ? 'pending' : 'active';

            var modelGrpId = '';
            if (typeof model.get("group") === 'object') {
              modelGrpId = model.get("group").get('_id');
            } else {
              modelGrpId = model.get("group");
            }

            if (modelGrpId !== this.displayGroup.get("_id"))
                return;

            var listListeners = {
                'click': this.onMemberClick,
                'edit': this.onMemberEdit,
                'active': this.onMemberActive,
                'remove': this.onMemberRemove,
            };

            this.stopListeningTo(this.view.active.getCollection(), listListeners)
                .stopListeningTo(this.view.pending.getCollection(), listListeners)
                .stopListeningTo(this.view.inactive.getCollection(), listListeners);

            this.view.active.collection.remove([{ _id: model.get('_id') }]);
            this.view.inactive.collection.remove([{ _id: model.get('_id') }]);
            this.view.pending.collection.remove([{ _id: model.get('_id') }]);

            this.view[list].collection.set(model, { remove: false });

            // listeners
            this.listenTo(this.view.active.getCollection(), listListeners)
                .listenTo(this.view.pending.getCollection(), listListeners)
                .listenTo(this.view.inactive.getCollection(), listListeners);
        },

        resetMemberList: function(group) {
            this.displayGroup = group;
            var view = this.view,
                lists = [view.active, view.pending, view.inactive];
            this.allStatusCombinedMembers.reset();
            _.invoke(lists, 'resetList', group);
        },

        setQuery: function(value) {
            var view = this.view,
                lists = [view.active, view.pending, view.inactive];
            _.invoke(lists, 'setCollectionQuery', value);
        },

        getFirstAvailable: function() {
            var view = this.view;
            if (view.active.collection.models.length > 0)
                return view.active.collection.first();
            else if (view.pending.collection.models.length > 0)
                return view.pending.collection.first();
            else if (view.inactive.collection.models.length > 0)
                return view.inactive.collection.first();

            return null;
        },
        ////////////
        // events //
        ////////////

        onMemberActive: function(memberModel, value) {
            _.invoke(this.view, 'unselect');
        },

        onMemberClick: function(memberModel) {
            User.setSelectedUser(memberModel);
            this.unselect();
            CalendarEvents.calendarRenderStart();
            this.trigger("member:select", memberModel, this.collection);
        },

        onMemberEdit: function(memberModel) {
            this.trigger("member:edit", memberModel, this.collection);
        },

        onMemberRemove: function(memberModel) {
            this.allStatusCombinedMembers.remove(memberModel);
            if (this.allStatusCombinedMembers.models.length <= 0 && User.get('isHiddenFromClientsList')) {
                User.set('_fallbackMemberId', null);
            }
            this.trigger("member:remove", memberModel, this.collection);
        },

        onMemberAdded: function(memberModel) {
            this.allStatusCombinedMembers.add(memberModel);
        },

        onTestUserAdded: function () {
            this.resetMemberList(this.groups.first());
        }

    });

    return VMemberListsController;

});

